export default __webpack_public_path__ + "static/media/banner-pic.0b7826c8.png";